import axiosClient from "./axiosClient";

const serviceCategoryApi = {
    getAll: () =>{
        const url = 'api/serviceCategory/getall'
        return axiosClient.get(url)
    },
    getMenuAll: (language) =>{
        const url = `api/serviceCategory/getallMenu/${language}`
        return axiosClient.get(url)
    },
    getById: (params,data) =>{
        const url = `api/serviceCategory/${params}`
        return axiosClient.post(url,data)
    },
    getAdsService: (params, language) =>{
        const data = {    
            language: language,
            ads: true
        };
        const url = `api/serviceCategory/getads/${params}`
        return axiosClient.post(url, data)
    },
    
    getByIdOnly: (params) =>{
        const url = `api/serviceCategory/getbyid/${params}`
        return axiosClient.get(url,params)
    },
    updateById: (params,data) =>{
        const url = `api/serviceCategory/${params}`
        return axiosClient.put(url,data)
    },
    create: (data) =>{
        const url = `api/serviceCategory/create`
        return axiosClient.post(url,data)
    },
    delete: (params,data) =>{
        const url = `api/serviceCategory/${params}`
        return axiosClient.delete(url,data)
    },

}
export default serviceCategoryApi;